export default {
  state: {
    isAiAnswersDrawerOpen: false,
    refIndexSelected: '',
  },
  mutations: {
    SET_REF_INDEX_SELECTED(state, payload) {
      console.log('SET_REF_INDEX_SELECTED', payload)
      state.refIndexSelected = payload
    },
    SET_IS_AI_ANSWERS_DRAWER_OPEN(state, payload) {
      state.isAiAnswersDrawerOpen = payload
    },
  },
  getters: {
    GET_REF_INDEX_SELECTED(state) {
      return state.refIndexSelected
    },
    GET_IS_AI_ANSWERS_DRAWER_OPEN(state) {
      return state.isAiAnswersDrawerOpen
    },
  },
}
